const STYLE_ID = "dealer-map-marker-styles";
export const DEALER_MARKER_SIZE = 32;

const MARKER_STYLES = `
.dealer-map-marker__inner {
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  transform-origin: center bottom;
  transition: transform 0.38s cubic-bezier(0.34, 1.56, 0.64, 1);
  will-change: transform;
}
.dealer-map-marker__inner--active {
  transform: scale(1.45);
  z-index: 2;
}
.dealer-map-marker__inner img {
  width: ${DEALER_MARKER_SIZE}px;
  height: ${DEALER_MARKER_SIZE}px;
  display: block;
  cursor: pointer;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.18));
  transition: filter 0.3s ease;
}
.dealer-map-marker__inner--active img {
  filter: drop-shadow(0 4px 12px rgba(0, 147, 67, 0.45));
}
.dealer-map-marker__count {
  position: absolute;
  top: -5px;
  right: -8px;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  box-sizing: border-box;
  border-radius: 999px;
  background: #338ff0;
  border: 2px solid #fff;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  line-height: 14px;
  text-align: center;
  font-family: Arial, sans-serif;
  pointer-events: none;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.22);
  z-index: 1;
}
.dealer-map-marker__pulse {
  position: absolute;
  left: 50%;
  bottom: 2px;
  width: ${DEALER_MARKER_SIZE}px;
  height: ${DEALER_MARKER_SIZE}px;
  margin-left: -${DEALER_MARKER_SIZE / 2}px;
  border-radius: 50%;
  background: rgba(0, 147, 67, 0.38);
  opacity: 0;
  transform: scale(0.55);
  pointer-events: none;
}
.dealer-map-marker__inner--active .dealer-map-marker__pulse {
  animation: dealerMapMarkerPulse 1.8s ease-out infinite;
}
@keyframes dealerMapMarkerPulse {
  0% {
    opacity: 0.65;
    transform: scale(0.55);
  }
  70% {
    opacity: 0;
    transform: scale(1.85);
  }
  100% {
    opacity: 0;
    transform: scale(1.85);
  }
}
`;

export const getDealerCoordKey = (lng, lat) =>
  `${Number(lng).toFixed(6)},${Number(lat).toFixed(6)}`;

export const readDealerLatLng = (item) => {
  const lat = Number(item?.latitude ?? item?.lat);
  const lng = Number(item?.longitude ?? item?.lon ?? item?.lng);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  return { lat, lng };
};

export const ensureDealerMarkerStylesInjected = () => {
  if (typeof document === "undefined") return;
  if (document.getElementById(STYLE_ID)) return;
  const style = document.createElement("style");
  style.id = STYLE_ID;
  style.textContent = MARKER_STYLES;
  document.head.appendChild(style);
};

export const createDealerMarkerElement = ({
  defaultIconUrl,
  activeIconUrl,
  onClick,
  count = 0,
}) => {
  ensureDealerMarkerStylesInjected();

  const root = document.createElement("div");
  // 勿给 root 设 position/transform，MapLibre 依赖 absolute + transform 定位
  root.className = "dealer-map-marker";

  const inner = document.createElement("div");
  inner.className = "dealer-map-marker__inner";

  const pulse = document.createElement("div");
  pulse.className = "dealer-map-marker__pulse";

  const img = document.createElement("img");
  img.src = defaultIconUrl;
  img.alt = "";

  inner.appendChild(pulse);
  inner.appendChild(img);

  if (Number(count) > 1) {
    const badge = document.createElement("span");
    badge.className = "dealer-map-marker__count";
    badge.textContent = String(count);
    inner.appendChild(badge);
  }

  root.appendChild(inner);

  const restartPulse = () => {
    pulse.style.animation = "none";
    void pulse.offsetWidth;
    pulse.style.animation = "";
  };

  const setActive = (active) => {
    root.style.zIndex = active ? "2" : "";
    if (active) {
      inner.classList.add("dealer-map-marker__inner--active");
      img.src = activeIconUrl;
      restartPulse();
      return;
    }
    inner.classList.remove("dealer-map-marker__inner--active");
    img.src = defaultIconUrl;
  };

  if (onClick) {
    img.addEventListener("click", (e) => {
      e.stopPropagation();
      onClick();
    });
  }

  return { root, setActive };
};
